// extracted by mini-css-extract-plugin
export var link = "_rx-0";